import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHourglass: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconHourglass"><Path d="M12 12L7.13284 8.88502C6.27124 8.33359 5.75 7.38115 5.75 6.3582V2.75H18.25V6.3582C18.25 7.38115 17.7288 8.33359 16.8672 8.88502L12 12ZM12 12L16.8672 15.115C17.7288 15.6664 18.25 16.6188 18.25 17.6418V21.25H5.75V17.6418C5.75 16.6188 6.27124 15.6664 7.13284 15.115L12 12ZM20.25 21.25H3.75M20.25 2.75H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconHourglass;
